// Russian translations
const translations = {
  common: {
    smartCity: 'Умный Город',
    dashboard: 'Панель управления',
    map: 'Карта',
    analytics: 'Аналитика',
    settings: 'Настройки',
    profile: 'Профиль',
    notifications: 'Уведомления',
    helpSupport: 'Помощь и поддержка',
    systemStatus: 'Статус системы',
    search: 'Поиск...',
    signOut: 'Выйти',
    systemRunningNormally: 'Система работает нормально',
    viewAllNotifications: 'Просмотреть все уведомления',
    toggleColorMode: 'Переключить режим цвета',
    administrator: 'Администратор',
    type: 'Тип',
    sensors: 'Датчики',
    coordinates: 'Координаты',
    view: 'Просмотр',
    details: 'Детали',
    active: 'Активный',
    inactive: 'Неактивный',
    maintenance: 'Обслуживание',
    all: 'Все',
    error: 'Ошибка',
    errorLoadingData: 'Ошибка загрузки данных',
    refresh: 'Обновить',
    success: 'Успех',
    required: 'Это поле обязательно',
    invalidValue: 'Недопустимое значение',
    invalidRange: 'Значение вне допустимого диапазона',
    operational: 'Работает',
    notOperational: 'Не работает',
    timestamp: 'Временная метка',
    deviceId: 'ID устройства',
    lastUpdated: 'Последнее обновление',
    exportData: 'Экспорт данных',
    saveChanges: 'Сохранить изменения',
    updateFailed: 'Ошибка обновления',
    errorLoadingLocation: 'Ошибка загрузки данных о местоположении',
    backToLocations: 'Назад к местоположениям',
    description: 'Описание',
    multiSelect: 'Множественный выбор',
    clearSelection: 'Очистить выбор',
    delete: 'Удалить',
  },
  // Добавить настройки системы и конфигурации
  settings: {
    dashboard: 'Панель настроек',
    system: 'Системные настройки',
    user: 'Пользовательские настройки',
    organization: 'Настройки организации',
    security: 'Настройки безопасности',
    notifications: 'Настройки уведомлений',
    integrations: 'Настройки интеграции',
    maintenance: 'Настройки обслуживания',

    // Управление пользователями
    'User Management': 'Управление пользователями',
    'User Profiles': 'Профили пользователей',
    'Role Management': 'Управление ролями',
    'Permission Settings': 'Настройки разрешений',
    'Access Control': 'Контроль доступа',
    'User Groups': 'Группы пользователей',
    Authentication: 'Аутентификация',
    'Session Management': 'Управление сессиями',

    // Системная конфигурация
    'System Configuration': 'Системная конфигурация',
    'General Settings': 'Общие настройки',
    'Performance Settings': 'Настройки производительности',
    'Database Settings': 'Настройки базы данных',
    'Cache Settings': 'Настройки кэша',
    'Logging Settings': 'Настройки логирования',
    'Backup Settings': 'Настройки резервного копирования',
    'Import/Export': 'Импорт/Экспорт',

    // API и настройки интеграции
    'API Configuration': 'Конфигурация API',
    'Rate Limiting': 'Ограничение скорости',
    'Webhook Settings': 'Настройки веб-хуков',
    'External APIs': 'Внешние API',
    'Data Sync': 'Синхронизация данных',
    'Protocol Settings': 'Настройки протокола',
    'Connection Testing': 'Тестирование соединения',
    'Integration Status': 'Статус интеграции',

    // Управление уведомлениями
    'Notification Types': 'Типы уведомлений',
    'Email Settings': 'Настройки электронной почты',
    'SMS Settings': 'Настройки SMS',
    'Push Notifications': 'Push-уведомления',
    'Alert Preferences': 'Настройки оповещений',
    'Delivery Methods': 'Способы доставки',
    'Escalation Rules': 'Правила эскалации',
    'Notification Templates': 'Шаблоны уведомлений',

    // Конфигурация безопасности
    'Password Policy': 'Политика паролей',
    'Two-Factor Authentication': 'Двухфакторная аутентификация',
    'IP Restrictions': 'IP-ограничения',
    'SSL/TLS Settings': 'Настройки SSL/TLS',
    'Encryption Settings': 'Настройки шифрования',
    'Audit Logging': 'Аудит-логи',
    'Compliance Settings': 'Настройки соответствия',
    'Security Monitoring': 'Мониторинг безопасности',

    // Управление данными
    'Data Retention': 'Хранение данных',
    'Data Archiving': 'Архивирование данных',
    'Data Purging': 'Очистка данных',
    'Data Quality': 'Качество данных',
    'Data Sources': 'Источники данных',
    'Data Validation': 'Валидация данных',
    'Data Migration': 'Миграция данных',
    'Data Backup': 'Резервное копирование данных',

    // Настройки приложения
    'Theme Settings': 'Настройки темы',
    'Language Settings': 'Языковые настройки',
    'Timezone Settings': 'Настройки часового пояса',
    'Display Settings': 'Настройки отображения',
    'Layout Settings': 'Настройки макета',
    'Dashboard Preferences': 'Настройки панели управления',
    'Widget Configuration': 'Конфигурация виджетов',
    'Chart Settings': 'Настройки графиков',

    // Мониторинг системы
    'Health Monitoring': 'Мониторинг состояния',
    'Performance Monitoring': 'Мониторинг производительности',
    'Resource Usage': 'Использование ресурсов',
    'System Alerts': 'Системные оповещения',
    'Error Tracking': 'Отслеживание ошибок',
    'Diagnostic Tools': 'Диагностические инструменты',
    'System Status': 'Статус системы',
    'Maintenance Windows': 'Окна обслуживания',

    // Dashboard settings UI
    configurePreferences: 'Настройте параметры панели управления',
    generalSettings: 'Общие настройки',
    displaySettings: 'Настройки отображения',
    notificationSettings: 'Настройки уведомлений',
    advancedSettings: 'Расширенные настройки',
    language: 'Язык',
    languages: {
      english: 'Английский',
      russian: 'Русский',
      kazakh: 'Казахский',
    },
    theme: 'Тема',
    light: 'Светлая',
    dark: 'Темная',
    systemDefault: 'Системная',
    enableNotifications: 'Включить уведомления',
    emailAlerts: 'Оповещения по электронной почте',
    dataRefreshInterval: 'Интервал обновления данных (минуты)',
    defaultMapView: 'Вид карты по умолчанию',
    trafficView: 'Вид трафика',
    satelliteView: 'Спутниковый вид',
    streetsView: 'Вид улиц',
    darkView: 'Темный вид',
    dashboardLayout: 'Макет панели управления',
    grid: 'Сетка',
    list: 'Список',
    compact: 'Компактный',
    colorScheme: 'Цветовая схема',
    blue: 'Синяя',
    green: 'Зеленая',
    purple: 'Фиолетовая',
    orange: 'Оранжевая',
    red: 'Красная',
    dataCardSize: 'Размер карточки данных',
    small: 'Маленький',
    medium: 'Средний',
    large: 'Большой',
    showLegends: 'Показывать легенды на графиках',
    trafficIncidents: 'Дорожные происшествия',
    sensorOfflineAlerts: 'Оповещения о выходе датчиков из сети',
    congestionAlerts: 'Оповещения о пробках',
    systemUpdates: 'Обновления системы',
    dailyReports: 'Ежедневные отчеты',
    advancedUsersNote: 'Эти настройки предназначены для опытных пользователей.',
    apiKey: 'API ключ',
    apiKeyNote: 'Этот ключ используется для внешних интеграций.',
    developerMode: 'Режим разработчика',
    debuggingTools: 'Включает расширенные инструменты отладки',
    dataRetention: 'Хранение данных (дни)',
    logLevel: 'Уровень журналирования',
    warning: 'Предупреждение',
    info: 'Информация',
    debug: 'Отладка',
    trace: 'Трассировка',
    betaFeatures: 'Включить бета-функции',
    resetDefaults: 'Сбросить настройки',
    saveSettings: 'Сохранить настройки',
    saving: 'Сохранение',
    general: 'Общие',
    integrationsTab: 'Интеграции',
    integrationsDescription:
      'Настройте интеграции с третьими сторонами, API-конечные точки и сопоставления полей для вашей панели управления умным городом.',
  },

  // Добавить пользовательский интерфейс и компоненты
  ui: {
    navigation: 'Навигация',
    menu: 'Меню',
    toolbar: 'Панель инструментов',
    sidebar: 'Боковая панель',
    footer: 'Нижний колонтитул',
    header: 'Заголовок',
    breadcrumb: 'Хлебные крошки',
    pagination: 'Пагинация',

    // Элементы формы
    'Form Elements': 'Элементы формы',
    'Input Fields': 'Поля ввода',
    'Select Boxes': 'Списки выбора',
    'Check Boxes': 'Флажки',
    'Radio Buttons': 'Переключатели',
    'Text Areas': 'Текстовые области',
    'File Uploads': 'Загрузка файлов',
    'Date Pickers': 'Выбор даты',
    'Time Pickers': 'Выбор времени',

    // Кнопки и действия
    'Primary Button': 'Основная кнопка',
    'Secondary Button': 'Вторичная кнопка',
    'Submit Button': 'Кнопка отправки',
    'Cancel Button': 'Кнопка отмены',
    'Reset Button': 'Кнопка сброса',
    'Edit Button': 'Кнопка редактирования',
    'Delete Button': 'Кнопка удаления',
    'Save Button': 'Кнопка сохранения',
    'Apply Button': 'Кнопка применения',
    'Close Button': 'Кнопка закрытия',
    'Back Button': 'Кнопка назад',
    'Next Button': 'Кнопка далее',
    'Previous Button': 'Кнопка назад',
    'Refresh Button': 'Кнопка обновления',
    'Search Button': 'Кнопка поиска',
    'Clear Button': 'Кнопка очистки',
    'Export Button': 'Кнопка экспорта',
    'Import Button': 'Кнопка импорта',
    'Download Button': 'Кнопка загрузки',
    'Upload Button': 'Кнопка выгрузки',

    // Модальные окна и диалоги
    'Modal Dialog': 'Модальное окно',
    'Confirmation Dialog': 'Диалог подтверждения',
    'Alert Dialog': 'Диалог оповещения',
    'Info Dialog': 'Информационный диалог',
    'Warning Dialog': 'Диалог предупреждения',
    'Error Dialog': 'Диалог ошибки',
    'Success Dialog': 'Диалог успеха',
    'Progress Dialog': 'Диалог прогресса',

    // Отображение данных
    'Data Table': 'Таблица данных',
    'Data Grid': 'Сетка данных',
    'List View': 'Список',
    'Card View': 'Карточки',
    'Tree View': 'Дерево',
    'Chart View': 'Графики',
    'Map View': 'Карта',
    'Detail View': 'Детальный вид',

    // Загрузка и статус
    'Loading Spinner': 'Индикатор загрузки',
    'Progress Bar': 'Полоса прогресса',
    'Status Indicator': 'Индикатор статуса',
    Badge: 'Значок',
    Label: 'Метка',
    Tag: 'Тег',
    Chip: 'Чип',
    Tooltip: 'Подсказка',

    // Макет и расположение
    'Grid Layout': 'Сеточный макет',
    'Flex Layout': 'Гибкий макет',
    'Card Layout': 'Карточный макет',
    'Panel Layout': 'Панельный макет',
    'Tab Layout': 'Вкладочный макет',
    'Accordion Layout': 'Аккордеонный макет',
    'Sidebar Layout': 'Боковой макет',
    'Split Layout': 'Разделенный макет',
  },

  dashboard: {
    trafficOverview: 'Обзор трафика',
    recentEvents: 'Недавние события',
    sensorStatus: 'Статус датчиков',
    systemHealth: 'Состояние системы',
    trafficVolume: 'Объем трафика',
    incidents: 'Инциденты',
    events: 'События',
    sensors: 'Датчики',
    reports: 'Отчеты',
    calendar: 'Календарь',
    signalStatus: 'Статус сигналов',
    averageTravelTime: 'Среднее время в пути',
    viewDetails: 'Подробнее',
    viewAll: 'Смотреть все',
    online: 'В сети',
    offline: 'Не в сети',
    uptime: 'Время безотказной работы',
    responseTime: 'Время отклика',
    dataPoints: 'Точки данных',
    lastUpdate: 'Последнее обновление',

    // Added new location page translations
    addNew: 'Добавить новый',
    searchLocations: 'Поиск местоположений...',
    filterByType: 'Фильтр по типу',
    filterByStatus: 'Фильтр по статусу',
    grid: 'Сетка',
    list: 'Список',
    noLocationsFound: 'Местоположения не найдены',
    tryDifferentSearch: 'Попробуйте другой поисковый запрос или фильтр',
    locationsDescription: 'Управление и мониторинг данных о местоположениях',

    // Add location modal translations
    addNewLocation: 'Добавить новое местоположение',
    locationNamePlaceholder: 'Введите название местоположения',
    locationAddressPlaceholder: 'Введите адрес',
    locationTypePlaceholder: 'Например, перекресток, шоссе и т.д.',
    locationAddedSuccess: 'Местоположение успешно добавлено',
    locationDeletedSuccess: 'Местоположение успешно удалено',
    locationDeleteFailed: 'Не удалось удалить местоположение',
    deleteLocationsTitle: 'Удалить местоположения',
    deleteLocationsConfirm: 'Вы уверены, что хотите удалить {{count}} местоположений?',
    deleteLocationsWarning:
      'Это действие нельзя отменить. Все датчики, подключенные к этим местоположениям, будут отключены.',
    bulkDeleteSuccess: 'Успешно удалено {{count}} местоположений',
    bulkDeletePartialSuccess:
      'Частично успешно: удалено {{success}} местоположений, не удалось удалить {{failed}}',
    bulkDeleteFailed: 'Не удалось удалить местоположения',
    locationUpdatedSuccess: 'Местоположение успешно обновлено',
    editLocationDesc: 'Редактировать детали и координаты местоположения',
    locationDescriptionPlaceholder: 'Введите описание местоположения (необязательно)',
    locationsMap: 'Карта местоположений',
  },

  map: {
    trafficSensors: 'Датчики движения',
    nearbyEvents: 'События поблизости',
    fullScreen: 'Полный экран',
    noEventsInArea: 'В этой области нет событий',
    sensorDetails: 'Информация о датчике',
    status: 'Статус',
    location: 'Местоположение',
    lastReading: 'Последние показания',
    trafficFlow: 'Поток трафика',
    averageSpeed: 'Средняя скорость',
  },

  analytics: {
    title: 'Панель аналитики',
    timeRangeFilter: 'Временной диапазон',
    sensorType: 'Тип датчика',
    applyFilters: 'Применить фильтры',
    trafficVolumeOverTime: 'Объем трафика с течением времени',
    vehicleTypeDistribution: 'Распределение типов транспортных средств',
    congestionMetrics: 'Показатели загруженности',
    averageDailyTraffic: 'Средний дневной трафик',
    peakHourVolume: 'Объем в часы пик',
    congestionIndex: 'Индекс загруженности',
    // Time range options
    timeRange: {
      day: 'Последние 24 часа',
      week: 'Последние 7 дней',
      month: 'Последние 30 дней',
    },
    metricType: {
      traffic: 'Объем трафика',
      speed: 'Скорость транспортных средств',
      incidents: 'Дорожные происшествия',
    },
    metrics: {
      totalTraffic: 'Общий объем трафика',
      avgSpeed: 'Средняя скорость',
      congestionLevel: 'Уровень загруженности',
      incidentCount: 'Количество происшествий',
    },
    trafficByLocation: 'Трафик по местоположению',
    trafficTrends: 'Тенденции трафика',
    trafficPatterns: 'Схемы трафика',
    speedByLocation: 'Скорость по местоположению',
    speedTrends: 'Тенденции скорости во времени',
    speedDistribution: 'Распределение диапазонов скорости',
    speedPatterns: 'Схемы скорости по времени',
    incidentsByLocation: 'Происшествия по местоположению',
    incidentTrends: 'Тенденции происшествий',
    incidentTypes: 'Распределение типов происшествий',
    incidentPatterns: 'Схемы происшествий',
  },

  profile: {
    userProfile: 'Профиль пользователя',
    editProfile: 'Редактировать профиль',
    cancel: 'Отмена',
    department: 'Отдел',
    accessLevel: 'Уровень доступа',
    memberSince: 'Участник с',
    lastLogin: 'Последний вход',
    personalInfo: 'Персональная информация',
    security: 'Безопасность',
    activeSessions: 'Активные сессии',
    fullName: 'Полное имя',
    emailAddress: 'Адрес электронной почты',
    phoneNumber: 'Номер телефона',
    bio: 'Биография',
    emailPrivacy: 'Мы никогда не будем делиться вашей электронной почтой.',
    password: 'Пароль',
    lastPasswordChange: 'Последнее изменение 30 дней назад',
    changePassword: 'Изменить пароль',
    twoFactorAuth: 'Двухфакторная аутентификация',
    enabled: 'Включено',
    disabled: 'Отключено',
    enable: 'Включить',
    disable: 'Отключить',
    accountActivityNotifications: 'Уведомления об активности аккаунта',
    willReceiveNotifications: 'Вы будете получать уведомления об активности аккаунта',
    wontReceiveNotifications: 'Вы не будете получать уведомления об активности аккаунта',
    currentSessions: 'Текущие активные сессии',
    sessionsDescription: 'Это устройства, которые входили в ваш аккаунт.',
    lastAccessed: 'Последний доступ',
    terminate: 'Завершить',
    logoutAllDevices: 'Выйти со всех устройств',
  },

  notifications: {
    all: 'Все',
    unread: 'Непрочитанные',
    read: 'Прочитанные',
    archived: 'Архивированные',
    markAsRead: 'Отметить как прочитанное',
    actions: 'Действия',
    markAsUnread: 'Отметить как непрочитанное',
    archive: 'Архивировать',
    delete: 'Удалить',
    filterByType: 'Фильтр по типу',
    allTypes: 'Все типы',
    incident: 'Инцидент',
    system: 'Система',
    maintenance: 'Обслуживание',
    alert: 'Оповещение',
    info: 'Информация',
    filterBySeverity: 'Фильтр по важности',
    allSeverities: 'Все уровни важности',
    low: 'Низкий',
    medium: 'Средний',
    high: 'Высокий',
    critical: 'Критический',
    filterByStatus: 'Фильтр по статусу',
    allStatuses: 'Все статусы',
    selectAll: 'Выбрать все',
    notificationsCount: 'уведомлений',
    noNotificationsFound: 'Не найдено уведомлений, соответствующих вашим фильтрам',
    actionRequired: 'Требуется действие',
    source: 'Источник',
    relatedTo: 'Связано с',
    noUnread: 'Нет непрочитанных уведомлений',
    noRead: 'Нет прочитанных уведомлений',
    noArchived: 'Нет архивированных уведомлений',
    justNow: 'Только что',
    minutesAgo: '{{count}} минут назад',
    hoursAgo: '{{count}} часов назад',
    yesterday: 'Вчера',
    daysAgo: '{{count}} дней назад',
  },

  search: {
    advancedSearch: 'Расширенный поиск',
    searchPlaceholder: 'Поиск событий, датчиков или местоположений...',
    search: 'Поиск',
    moreFilters: 'Больше фильтров',
    lessFilters: 'Меньше фильтров',
    activeFilters: 'Активные фильтры',
    clearAll: 'Очистить все',
    eventTypes: 'Типы событий',
    locations: 'Местоположения',
    vehicleTypes: 'Типы транспортных средств',
    car: 'Автомобиль',
    bus: 'Автобус',
    truck: 'Грузовик',
    motorcycle: 'Мотоцикл',
    bicycle: 'Велосипед',
    speedRange: 'Диапазон скорости',
    customFilter: 'Пользовательский фильтр',
    eventType: 'Тип события',
    location: 'Местоположение',
    timestamp: 'Временная метка',
    sensorType: 'Тип датчика',
    speed: 'Скорость',
    status: 'Статус',
    equals: 'Равно',
    contains: 'Содержит',
    greaterThan: 'Больше чем',
    lessThan: 'Меньше чем',
    range: 'Диапазон',
    addFilter: 'Добавить фильтр',
    results: 'Результаты',
    selectEventType: 'Выберите тип события',
    selectLocation: 'Выберите местоположение',
    selectSensorType: 'Выберите тип датчика',
    enterSpeed: 'Введите скорость в км/ч',
    enterValue: 'Введите значение',
  },

  events: {
    // ... existing translations ...
  },

  sensors: {
    // ... existing translations ...
  },

  reports: {
    // ... existing translations ...
  },

  calendar: {
    month: 'Месяц',
    week: 'Неделя',
    day: 'День',
    list: 'Список',
    addEvent: 'Добавить событие',
    eventDetails: 'Детали события',
    title: 'Заголовок',
    description: 'Описание',
    location: 'Местоположение',
    startDate: 'Дата и время начала',
    endDate: 'Дата и время окончания',
    allDay: 'Весь день',
    eventType: 'Тип события',
    priority: 'Приоритет',
    status: 'Статус',
    trafficEvent: 'Дорожное событие',
    maintenance: 'Обслуживание',
    meeting: 'Встреча',
    alert: 'Оповещение',
    other: 'Другое',
    low: 'Низкий',
    medium: 'Средний',
    high: 'Высокий',
    pending: 'Ожидание',
    inProgress: 'В процессе',
    completed: 'Завершено',
    cancelled: 'Отменено',
    save: 'Сохранить',
    delete: 'Удалить',
    cancel: 'Отмена',
    loading: 'Загрузка календаря...',
    eventCreated: 'Событие создано',
    eventUpdated: 'Событие обновлено',
    eventDeleted: 'Событие удалено',
    assignees: 'Назначенные',
    yes: 'Да',
    no: 'Нет',
    // FullCalendar specific translations
    currentDay: 'Сегодня',
    dayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
    dayNamesShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    monthNames: [
      'Январь',
      'Февраль',
      'Март',
      'Апрель',
      'Май',
      'Июнь',
      'Июль',
      'Август',
      'Сентябрь',
      'Октябрь',
      'Ноябрь',
      'Декабрь',
    ],
    monthNamesShort: [
      'Янв',
      'Фев',
      'Мар',
      'Апр',
      'Май',
      'Июн',
      'Июл',
      'Авг',
      'Сен',
      'Окт',
      'Ноя',
      'Дек',
    ],
    buttonText: {
      today: 'Сегодня',
      month: 'Месяц',
      week: 'Неделя',
      day: 'День',
      list: 'Список',
    },
    allDayText: 'Весь день',
    moreLinkText: 'ещё',
    noEventsText: 'Нет событий для отображения',
    // Add locale property for FullCalendar
    locale: 'ru',
  },

  integration: {
    apiKeys: 'API-ключи',
    createApiKey: 'Создать API-ключ',
    deleteApiKey: 'Удалить API-ключ',
    regenerateApiKey: 'Перегенерировать API-ключ',
    apiKeyName: 'Название API-ключа',
    apiKeyValue: 'Значение API-ключа',
    apiKeyCreated: 'API-ключ создан',
    apiKeyDeleted: 'API-ключ удален',
    apiKeyRegenerated: 'API-ключ перегенерирован',
    copyApiKey: 'Копировать API-ключ',
    confirmDeleteApiKey: 'Вы уверены, что хотите удалить этот API-ключ?',
    noApiKeys: 'API-ключи не найдены',

    endpoints: 'Конечные точки',
    createEndpoint: 'Создать конечную точку',
    deleteEndpoint: 'Удалить конечную точку',
    endpointName: 'Название конечной точки',
    endpointUrl: 'URL конечной точки',
    endpointMethod: 'Метод',
    endpointCreated: 'Конечная точка создана',
    endpointDeleted: 'Конечная точка удалена',
    noEndpoints: 'Конечные точки не найдены',

    fieldMappings: 'Сопоставления полей',
    createMapping: 'Создать сопоставление',
    deleteMapping: 'Удалить сопоставление',
    mappingName: 'Название сопоставления',
    sourceField: 'Исходное поле',
    targetField: 'Целевое поле',
    mappingCreated: 'Сопоставление создано',
    mappingDeleted: 'Сопоставление удалено',
    noMappings: 'Сопоставления полей не найдены',

    testIntegrations: 'Тестирование интеграций',
    savedTests: 'Сохраненные тесты',
    testConfiguration: 'Конфигурация теста',
    testName: 'Название теста',
    testDescription: 'Описание теста',
    method: 'Метод',
    endpoint: 'Конечная точка',
    headers: 'Заголовки',
    headerKey: 'Ключ заголовка',
    headerValue: 'Значение заголовка',
    requestBody: 'Тело запроса',
    jsonBody: 'JSON-тело',
    execute: 'Выполнить',
    response: 'Ответ',
    testSaved: 'Тест успешно сохранен',
    testDeleted: 'Тест успешно удален',
    locationAddedSuccess: 'Локация успешно добавлена',
    locationDeletedSuccess: 'Локация успешно удалена',
    locationDeleteFailed: 'Не удалось удалить локацию',
    deleteLocationsTitle: 'Удалить локации',
    deleteLocationsConfirm: 'Вы уверены, что хотите удалить {{count}} локаций?',
    deleteLocationsWarning:
      'Это действие нельзя отменить. Все датчики, подключенные к этим локациям, будут отключены.',
    bulkDeleteSuccess: 'Успешно удалено {{count}} локаций',
    bulkDeletePartialSuccess:
      'Частично успешно: удалено {{success}} локаций, не удалось удалить {{failed}}',
    bulkDeleteFailed: 'Не удалось удалить локации',
    noSavedTests: 'Сохраненные тесты не найдены',
    requiredFields: 'Название и конечная точка обязательны',
    endpointRequired: 'Конечная точка обязательна',
  },

  users: {
    // ... existing translations ...
  },

  // Add sidebar translations
  sidebar: {
    app: {
      name: 'Умный Город',
    },
    main: 'Главная',
    overview: 'Обзор',
    dashboard: 'Панель управления',
    map: 'Карта',
    calendar: 'Календарь',
    analytics: 'Аналитика',
    search: 'Поиск',
    notifications: 'Уведомления',
    location: 'Местоположение',
    incidents: 'Инциденты',
    archive: 'Архив',
    monitoring: 'Мониторинг',
    sensorManagement: 'Управление датчиками',
    sensors: 'Датчики',
    sensorHealth: 'Состояние датчиков',
    events: 'События',
    trafficManagement: 'Управление трафиком',
    trafficLogs: 'Журналы трафика',
    trafficEvents: 'События трафика',
    trafficViolations: 'Нарушения ПДД',
    seatbeltViolations: 'Непристегнутые ремни',
    seatbeltEvents: 'События непристегнутых ремней',
    trafficAnalytics: 'Аналитика трафика',
    reports: 'Отчеты',
    administration: 'Администрирование',
    users: 'Пользователи',
    userRoles: 'Роли пользователей',
    account: 'Аккаунт',
    profile: 'Профиль',
    profileSettings: 'Настройки профиля',
    system: 'Система',
    systemHealth: 'Состояние системы',
    integrations: 'Интеграции',
    translations: 'Переводы',
    storage: 'Хранилище',
    backups: 'Резервные копии',
    license: 'Лицензия',
    help: 'Помощь',
    queueManager: 'Менеджер очередей',
    workers: 'Работники',
  },

  // Add header translations
  header: {
    expandSidebar: 'Развернуть боковую панель',
    collapseSidebar: 'Свернуть боковую панель',
    language: 'Изменить язык',
    selectLanguage: 'Выбрать язык',
    recentNotifications: 'Недавние уведомления',
    notificationTitle: 'Системное предупреждение',
    notificationDesc: 'Новое системное предупреждение требует вашего внимания.',
    help: 'Помощь',
    toggleTheme: 'Переключить тему',
  },

  // Add new sensor health translations
  sensorHealth: {
    dashboard: 'Панель мониторинга датчиков',
    overview: 'Обзор состояния датчиков',
    details: 'Детали датчика',
    loading: 'Загрузка датчика...',
    error: 'Ошибка загрузки датчика',
    notFound: 'Датчик не найден',
    sensorNotFound: 'Датчик с ID {{id}} не найден',
    editSensor: 'Редактировать датчик',
    exportData: 'Экспорт данных',
    metrics: {
      uptime: 'Время работы',
      signalStrength: 'Сила сигнала',
      batteryLevel: 'Уровень заряда',
      responseTime: 'Время отклика',
      dataRate: 'Скорость передачи',
      temperature: 'Температура',
      humidity: 'Влажность',
      errorRate: 'Частота ошибок',
      packetLoss: 'Потеря пакетов',
      connectionStatus: 'Состояние подключения',
      operationalStatus: 'Рабочее состояние',
      firmwareVersion: 'Версия прошивки',
      hardwareVersion: 'Версия оборудования',
      lastCalibration: 'Последняя калибровка',
      selfTestStatus: 'Статус самодиагностики',
      lastUpdated: 'Последнее обновление',
    },
    alerts: 'Оповещения',
    status: {
      online: 'В сети',
      offline: 'Не в сети',
      warning: 'Предупреждение',
      error: 'Ошибка',
      maintenance: 'Техобслуживание',
      all: 'Все датчики',
      connected: 'Подключен',
      disconnected: 'Отключен',
      intermittent: 'Прерывистый',
      active: 'Активный',
      idle: 'Неактивный',
    },
    metricsData: {
      batteryLevel: 'Уровень заряда',
      signalStrength: 'Сила сигнала',
      uptime: 'Время работы',
      responseTime: 'Время отклика',
      dataRate: 'Скорость передачи',
      temperature: 'Температура',
      humidity: 'Влажность',
      lastUpdated: 'Последнее обновление',
    },
    alertsData: {
      title: 'Оповещения',
      noAlerts: 'Нет оповещений',
      lowBattery: 'Низкий заряд',
      signalLoss: 'Потеря сигнала',
      highTemperature: 'Высокая температура',
      maintenance: 'Требуется техобслуживание',
      severity: {
        low: 'Низкая',
        medium: 'Средняя',
        high: 'Высокая',
        critical: 'Критическая',
      },
      status: {
        active: 'Активно',
        resolved: 'Решено',
        acknowledged: 'Принято',
        ignored: 'Игнорируется',
      },
    },
    diagnostics: {
      title: 'Диагностика',
      selfTest: 'Самодиагностика',
      passed: 'Пройдено',
      failed: 'Не пройдено',
      voltage: 'Напряжение',
      memory: 'Использование памяти',
      cpu: 'Использование ЦП',
      errorCodes: 'Коды ошибок',
    },
    performance: {
      title: 'Производительность',
      excellent: 'Отлично',
      good: 'Хорошо',
      fair: 'Удовлетворительно',
      poor: 'Плохо',
      packetLoss: 'Потеря пакетов',
      latency: 'Задержка',
      jitter: 'Джиттер',
      throughput: 'Пропускная способность',
    },
    filter: {
      searchPlaceholder: 'Поиск датчиков...',
      filterByStatus: 'Фильтровать по статусу',
      applyFilters: 'Применить фильтры',
      resetFilters: 'Сбросить фильтры',
      sortBy: 'Сортировать по',
      showAdvancedFilters: 'Показать расширенные фильтры',
      hideAdvancedFilters: 'Скрыть расширенные фильтры',
      clearAllFilters: 'Очистить все фильтры',
      searchByNameOrId: 'Поиск датчиков по имени или ID',
    },
    actions: {
      viewDetails: 'Просмотр деталей',
      refreshData: 'Обновить данные',
      exportData: 'Экспорт данных',
      createAlert: 'Создать оповещение',
      scheduleMaintenence: 'Запланировать техобслуживание',
      resetSensor: 'Сбросить датчик',
      selectSensor: 'Выберите датчик для просмотра деталей',
      chooseSensor: 'Выберите датчик',
      recalibrate: 'Перекалибровать',
      restart: 'Перезапустить',
      requiresAttention: 'Требует внимания',
    },
    stats: {
      totalSensors: 'Всего датчиков',
      healthySensors: 'Исправные датчики',
      warningSensors: 'Датчики с предупреждениями',
      criticalSensors: 'Критические датчики',
      maintenanceSensors: 'Датчики на техобслуживании',
      averageUptime: 'Среднее время работы',
      averageBattery: 'Средний заряд батареи',
      alertsLast24h: 'Оповещения (24ч)',
    },
    charts: {
      batteryLevelTrend: 'Тенденция уровня заряда',
      signalStrengthTrend: 'Тенденция силы сигнала',
      alertsOverTime: 'Оповещения по времени',
      statusDistribution: 'Распределение статусов',
      responseTimeTrend: 'Тенденция времени отклика',
      uptimePercentage: 'Процент времени работы',
    },
    tabs: {
      allSensors: 'Все датчики',
      healthy: 'Исправные',
      warning: 'Предупреждения',
      critical: 'Критические',
      maintenance: 'Техобслуживание',
    },
    healthLog: {
      title: 'Журнал состояния',
      noData: 'Данные журнала состояния недоступны',
      noLogsReceived: 'От этого датчика не получено записей журнала состояния',
      deviceStatus: 'Статус устройства',
      radarStatus: 'Статус радара',
      cameraStatus: 'Статус камеры',
      gpsStatus: 'Статус GPS',
      ledStatus: 'Статус LED',
      latestStatus: 'Сводка последнего состояния',
      systemHealth: 'Состояние системы',
      allSystemsOperational: 'Все системы работают',
      systemIssuesDetected: 'Обнаружены проблемы в системе',
      lastStatusUpdate: 'Последнее обновление статуса',
    },
  },

  // Пустые состояния - Информативные сообщения с иллюстрациями
  emptyStates: {
    // Датчики
    noSensors: {
      title: 'Датчики не найдены',
      description: 'Начните с добавления первого датчика для мониторинга трафика и сбора данных.',
      primaryAction: 'Добавить датчик',
      secondaryAction: 'Узнать больше',
    },
    noSensorsFiltered: {
      title: 'Нет подходящих датчиков',
      description:
        'Нет датчиков, соответствующих текущим критериям фильтрации. Попробуйте изменить фильтры или условия поиска.',
      primaryAction: 'Сбросить фильтры',
    },

    // Местоположения
    noLocations: {
      title: 'Местоположения не найдены',
      description:
        'Добавьте местоположения для организации датчиков и мониторинга трафика в определённых зонах.',
      primaryAction: 'Добавить местоположение',
      secondaryAction: 'Импортировать местоположения',
    },
    noLocationsFiltered: {
      title: 'Нет подходящих местоположений',
      description:
        'Нет местоположений, соответствующих вашему поиску. Попробуйте другой поисковый запрос или просмотрите все местоположения.',
      primaryAction: 'Очистить поиск',
    },

    // События
    noEvents: {
      title: 'События не найдены',
      description:
        'Дорожные события появятся здесь, когда датчики начнут фиксировать активность. Убедитесь, что ваши датчики онлайн и правильно настроены.',
      primaryAction: 'Проверить датчики',
      secondaryAction: 'Обновить',
    },
    noEventsFiltered: {
      title: 'Нет подходящих событий',
      description:
        'Нет событий, соответствующих текущим фильтрам. Попробуйте изменить диапазон дат, критерии фильтрации или проверить подключение датчиков.',
      descriptionWithQuery:
        'Нет событий, соответствующих «{{query}}». Попробуйте другие поисковые запросы, измените диапазон дат или проверьте критерии фильтрации.',
      descriptionWithEventId:
        'Событие с ID «{{query}}» не найдено. Проверьте правильность ID события.',
      primaryAction: 'Сбросить фильтры',
      secondaryAction: 'Обновить',
    },

    // Нарушения
    noViolations: {
      title: 'Нарушения не найдены',
      description:
        'Нет нарушений, соответствующих текущим фильтрам. Попробуйте изменить диапазон дат или тип нарушения.',
      primaryAction: 'Изменить фильтры',
      secondaryAction: 'Обновить',
    },

    // Нарушения ремней безопасности
    noSeatbeltViolations: {
      title: 'Нарушений ремней безопасности нет',
      description:
        'Нарушения ремней безопасности появятся здесь, когда датчики начнут их фиксировать. Убедитесь, что ваши датчики онлайн и настроены на обнаружение нарушений ремней безопасности.',
      primaryAction: 'Проверить датчики',
      secondaryAction: 'Обновить',
    },
    noSeatbeltViolationsFiltered: {
      title: 'Нет подходящих нарушений',
      description:
        'Нет нарушений ремней безопасности, соответствующих текущим фильтрам. Попробуйте изменить диапазон дат, критерии фильтрации или расширить параметры поиска.',
      descriptionWithQuery:
        'Нет нарушений ремней безопасности, соответствующих «{{query}}». Попробуйте другие поисковые запросы, измените диапазон дат или проверьте критерии фильтрации.',
      descriptionWithEventId:
        'Нарушение ремня безопасности с ID «{{query}}» не найдено. Проверьте правильность ID события.',
      primaryAction: 'Сбросить фильтры',
      secondaryAction: 'Обновить',
    },

    // Отчёты
    noReports: {
      title: 'Отчётов пока нет',
      description:
        'Создавайте настраиваемые отчёты для анализа дорожных паттернов, данных датчиков и нарушений за период времени.',
      primaryAction: 'Создать отчёт',
      secondaryAction: 'Просмотреть шаблоны',
    },

    // Уведомления
    noNotifications: {
      title: 'Уведомлений нет',
      description:
        'Вы в курсе всех событий! Новые уведомления появятся здесь при возникновении активности.',
      primaryAction: 'Настройки уведомлений',
    },
    allNotificationsRead: {
      title: 'Всё прочитано!',
      description: 'У вас нет непрочитанных уведомлений.',
      primaryAction: 'Показать все',
    },

    // Результаты поиска
    noSearchResults: {
      title: 'Результаты не найдены',
      description: 'Ничего не найдено. Попробуйте другие ключевые слова или расширьте поиск.',
      descriptionWithQuery:
        'По запросу «{{query}}» ничего не найдено. Попробуйте другие ключевые слова или проверьте правописание.',
      primaryAction: 'Очистить поиск',
      secondaryAction: 'Изменить фильтры',
      tipsTitle: 'Советы по поиску',
      tips: {
        checkSpelling: 'Проверьте правописание и попробуйте снова',
        useKeywords: 'Используйте более общие ключевые слова',
        removeFilters: 'Удалите некоторые фильтры для расширения поиска',
        tryDifferentTerms: 'Попробуйте другие поисковые запросы',
      },
    },

    // Архив
    noArchive: {
      title: 'Архивных событий нет',
      description:
        'События автоматически архивируются согласно политике хранения. Архивные события сохраняются для соответствия требованиям и исторического анализа при оптимизации активной базы данных.',
      primaryAction: 'Настроить политику хранения',
      secondaryAction: 'Узнать больше',
    },
    noArchiveFiltered: {
      title: 'Нет подходящих архивных событий',
      description:
        'Нет архивных событий, соответствующих текущим фильтрам. Попробуйте изменить диапазон дат, тип события или уровень важности.',
      descriptionWithQuery:
        'Нет архивных событий, соответствующих «{{query}}». Попробуйте другие поисковые запросы или измените критерии фильтрации.',
      primaryAction: 'Сбросить фильтры',
      secondaryAction: 'Обновить',
    },

    // Общие данные отсутствуют
    noData: {
      title: 'Данные недоступны',
      description:
        'В данный момент нет данных для отображения. Проверьте позже или попробуйте обновить.',
      primaryAction: 'Обновить',
    },
  },
};

export default translations;
